import axios from 'axios';
import { getAuth } from '../providers/AppAuthProvider';
import { API_BASE_URL as baseUrl } from 'src/utils/api-url';

const base = 'xpx-perps/chain-token-config';

async function authHeaders() {
  const { accessToken } = (await getAuth()) || {};
  return {
    Authorization: `Bearer ${accessToken}`,
    Accept: 'application/json',
  };
}

export async function listChainConfigs() {
  const headers = await authHeaders();
  return axios.get<any>(`${baseUrl}/${base}/chains`, { headers });
}

export async function listTokenConfigs(chainId: number | undefined, page: number, limit: number) {
  const params: Record<string, any> = { page, limit };
  if (chainId) params.chainId = chainId;
  const headers = await authHeaders();
  return axios.get<any>(`${baseUrl}/${base}/tokens`, { headers, params });
}

export async function updateChainConfig(
  chainId: number,
  depositEnabled: boolean,
  withdrawalEnabled: boolean,
) {
  const headers = await authHeaders();
  return axios.put<any>(
    `${baseUrl}/${base}/chains/${chainId}`,
    { deposit_enabled: depositEnabled, withdrawal_enabled: withdrawalEnabled },
    { headers },
  );
}

export async function updateTokenConfig(
  chainId: number,
  tokenAddress: string,
  depositEnabled: boolean,
  withdrawalEnabled: boolean,
) {
  const headers = await authHeaders();
  return axios.put<any>(
    `${baseUrl}/${base}/tokens`,
    {
      chain_id: chainId,
      token_address: tokenAddress,
      deposit_enabled: depositEnabled,
      withdrawal_enabled: withdrawalEnabled,
    },
    { headers },
  );
}
